webpackJsonp([0],{

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Event CSS Modifier
 * 
 * Remove / Add :hover pseudo-class from selector text
 * base on event use for interaction.
 * 
 * On mobile, we don't want :hover state because they always
 * show up, but we need them on desktop. There is also a need
 * for computer having both touch and mouse event.
 * 
 * This JS remove :hover selector when using touch event.
 * If a mouse event is use, the default selector is restored.
 */

// This object is "private" and should not be expose
var evtCssMod = {

    //
    // Variables
    //

    // Default selector, matching nothing, if a selectorText
    // is empty after modification.
    emptySelectorText: "#evtCssModEmpty",

    // Unique ID prefix
    uidPrefix: "evtCssMod",

    // Unique ID counter
    uidCount: 0,

    // Current event state applied to CSS modification
    eventState: "base",

    // Boolean mentionning if an event is currently initiated
    eventInitiate: false,

    // StyleSheet
    stylesheet: [],

    //
    // Functions
    //


    // Throw error
    //
    error: function error(msg) {
        throw "Event CSS Modifier : " + msg;
    },

    // Console log information
    //
    info: function info(msg) {
        console.info("Event CSS Modifier : " + msg);
    },

    // Apply and return a unique ID for the CSSStyleSheet
    //
    uid: function uid(CSSStyleSheet) {
        if (CSSStyleSheet && CSSStyleSheet.ownerNode) {
            if (CSSStyleSheet.ownerNode.id != "") {
                return CSSStyleSheet.ownerNode.id;
            } else {
                evtCssMod.uidCount = evtCssMod.uidCount + 1;
                return evtCssMod.uidPrefix + evtCssMod.uidCount;
            }
        }
        return false;
    },

    // Return a "cssText" without :hover pseudo-class
    //
    touchCssText: function touchCssText(cssText, selectorText) {

        // Build the new selector text without :hover
        //
        var arr = selectorText.split(",");
        var newSelectorText = "";

        for (var i = 0; i < arr.length; i++) {
            var selector = arr[i].trim();
            if (selector.match(":hover")) {
                continue;
            } else {
                if (newSelectorText != "") {
                    newSelectorText = newSelectorText + ", ";
                }
                newSelectorText = newSelectorText + selector;
            }
        }

        // If new selector text is empty, 
        // assign a selector matching nothing
        if (newSelectorText == "") {
            newSelectorText = evtCssMod.emptySelectorText;
        }

        // Replace selector of cssTest
        cssText = cssText.replace(selectorText, newSelectorText);

        return cssText;
    },

    // Parse rule list (recursive)
    //
    parseRuleList: function parseRuleList(CSSRuleList) {
        var rulelist = [];

        if (CSSRuleList) {
            // Loop through each rule in sheet
            for (var i = 0; i < CSSRuleList.length; i++) {

                // CSSStyleRule or CSSMediaRule
                var rule = CSSRuleList[i];
                // Temporary object with rulelist info
                var tmp = {
                    index: i
                };

                // CSSMediaRule
                if (rule.cssRules) {
                    // Store object name
                    tmp.type = 'CSSMediaRule';
                    // Recursion
                    tmp.rulelist = evtCssMod.parseRuleList(rule.cssRules);
                    // Push to array (if not empty)
                    if (tmp.rulelist.length > 0) {
                        rulelist.push(tmp);
                    }
                }
                // CSSStyleRule
                else {
                        // Store object name
                        tmp.type = 'CSSStyleRule';
                        // If selector text contain :hover pseudo-class
                        if (rule.selectorText && rule.selectorText.match(":hover")) {
                            // Store information about the selector
                            // Base : It's the original
                            // Touch : Modified for touch event
                            tmp.css = {};
                            tmp.css.base = rule.cssText;
                            tmp.css.touch = evtCssMod.touchCssText(rule.cssText, rule.selectorText);
                            // Push to array
                            rulelist.push(tmp);
                        }
                    }
            }
        }

        return rulelist;
    },

    // Parse all stylesheet
    //
    parseStyleSheet: function parseStyleSheet() {
        // Loop through each stylesheet
        for (var i = 0; i < document.styleSheets.length; i++) {
            var CSSStyleSheet = document.styleSheets[i];
            // Apply a unique ID to the stylesheet (if none)
            if (CSSStyleSheet.ownerNode.id == "") {
                var uid = CSSStyleSheet.ownerNode.id = evtCssMod.uid(CSSStyleSheet);
            }
            // Retreive the ID (if exist)
            else if (CSSStyleSheet.ownerNode.id) {
                    var uid = CSSStyleSheet.ownerNode.id;
                }
                // Can't assign or retreive ID
                else {
                        evtCssMod.error("Impossible to assing unique ID to stylesheet.");
                        continue;
                    }
            // Try to retreive the cssRules
            try {
                var cssRules = CSSStyleSheet.cssRules;
            } catch (err) {
                evtCssMod.info("Failed to read the 'cssRules' from '" + CSSStyleSheet.href + "'.");
                continue;
            }
            // Add to the stylesheed
            if (!evtCssMod.stylesheet[uid]) {
                evtCssMod.stylesheet.push({
                    id: uid,
                    reference: CSSStyleSheet,
                    rulelist: evtCssMod.parseRuleList(cssRules)
                });
            }
        }
    },

    // Replace a CSSStyleRule
    //
    replaceStyleRule: function replaceStyleRule(CSSGroupingRule, cssText, index) {
        CSSGroupingRule.deleteRule(index);
        CSSGroupingRule.insertRule(cssText, index);
    },

    // Update RuleList base on event
    //
    updateRuleList: function updateRuleList(CSSGroupingRule, rulelist) {
        for (var i = 0; i < rulelist.length; i++) {
            var rule = rulelist[i];

            // CSSMediaRule
            if (rule.type == 'CSSMediaRule') {
                evtCssMod.updateRuleList(CSSGroupingRule.cssRules[rule.index], rule.rulelist);
            }

            // CSSStyleRule
            else if (rule.type == 'CSSStyleRule') {
                    // Apply touch modified selector
                    if (evtCssMod.eventState == "touch") {
                        evtCssMod.replaceStyleRule(CSSGroupingRule, rule.css.touch, rule.index);
                    }
                    // Restore original (base) selector
                    else {
                            evtCssMod.replaceStyleRule(CSSGroupingRule, rule.css.base, rule.index);
                        }
                }
        }
    },

    // Update CSS Rules base on event for each stylesheet
    //
    update: function update() {
        for (var i = 0; i < evtCssMod.stylesheet.length; i++) {
            var stylesheet = evtCssMod.stylesheet[i];
            if (stylesheet.rulelist.length > 0) {
                evtCssMod.updateRuleList(stylesheet.reference, stylesheet.rulelist);
            }
        }
    },

    // Update CSS Rules base on event
    //
    updateEvent: function updateEvent(eventState) {
        // Save the event state
        evtCssMod.eventState = eventState;
        // Update
        evtCssMod.update();
    },

    // Touch Start
    //
    onTouchStart: function onTouchStart(evt) {
        // Update if not the "touch" state
        if (evtCssMod.eventState != "touch" && evtCssMod.eventInitiate == false) {
            evtCssMod.updateEvent("touch");
        }
        // Flag to prevent event execution in "mouse move"
        evtCssMod.eventInitiate = true;
    },

    onMouseMove: function onMouseMove(evt) {
        // Update if not the "base" state
        if (evtCssMod.eventState != "base" && evtCssMod.eventInitiate == false) {
            evtCssMod.updateEvent("base");
        }
        // Flag to restore event execution in "mouse move"
        if (evtCssMod.eventInitiate) {
            evtCssMod.eventInitiate = false;
        }
    },

    // Init
    //
    init: function init() {
        // Parse stylesheet to build new rule
        evtCssMod.parseStyleSheet();
        // If device support touch, 
        // there's a high chance it's a mobile (touch).
        // Transform the CSS by anticipation.
        if ('ontouchstart' in window) {
            evtCssMod.updateEvent("touch");
        };
        // Listen for event
        document.addEventListener("touchstart", evtCssMod.onTouchStart, false);
        document.addEventListener("mousemove", evtCssMod.onMouseMove, false);
    }
};

// Expose the "eventCssModifier" to be used
// has an API
module.exports = {
    init: evtCssMod.init,
    update: evtCssMod.update
};

/***/ })

});


// WEBPACK FOOTER //
// 8fbd10e00b769ec0a7d6.js